import React, { FC, useEffect, useState } from 'react'
import { useLocation } from "react-router-dom";
import { parse } from "query-string";
import { Form } from "antd";
import EquipmentLatestDataFilter from "./EquipmentLatestData.filter";
import EquipmentLatestDataing from "./EquipmentLatestData.listing";
import EquipmentLatestDataPagination from "./EquipmentLatestData.pagination";
import { DeviceApi } from '../../../../api';
import { useCrudListService } from '../../../../hooks/crud/useCrudListService';
import { Card2 } from './Card2';
// import { Card2 } from '../../../content/cards/Card2';

const initialState = {
    search: '',
    entity: {},
    entityId: null,
    listData: [],
    filters: {
        status: '',
    },
    pagination: {
        currentPage: 1,
        pageSize: 10,
    },
    totalCount: 0,
    selectedRowKeys: [],
    sort: 'id desc',
    view: null,
    loading: false,
    isShowView: false,
    isShowForm: false,
    isShowPartialUpdateForm: false,
    fields: {},
    bulkAction: {
        action: '',
        field: '',
        value: '',
        ids: [] as any,
    },
    message: {
        network_error: 'A network error occurred. Please try again later.',
        delete_success: 'Delete icon successfully.',
        delete_confirm_title: 'Delete Device',
        delete_confirm: 'Are you sure you want to delete this icon?',
        delete_bulk_select: 'Please select item(s)',
        delete_bulk_confirm: 'Are you sure you wish to delete selected icon?',
    }
}

const EquipmentLatestDataController: FC<any> = props => {
    const location = useLocation();
    const queryParams = parse(location.search);

    const queryState = {
        filters: {
            status: queryParams?.status || initialState.filters.status,
        }
    }

    const { BaseCrudListService, formRef, payload, setFilters, initialValues, listData, search, filters, sort, pagination, totalCount, loading,
        entityId, isShowView, isShowForm, setIsShowForm, isShowPartialUpdateForm, selectedRowKeys, bulkAction, reloadListing, reloadView, reloadForm } = useCrudListService(DeviceApi, queryState, initialState, props);

    useEffect(() => {
        initData();
    }, [search, filters, sort, pagination, reloadListing])

    useEffect(() => {
        handleUrl();
    }, [entityId, isShowView, isShowForm, isShowPartialUpdateForm])

    useEffect(() => {
        if (bulkAction.action !== '') {
            executeBulkAction();
        }
    }, [bulkAction])

    const initData = async () => {
        await handleUrl();
        await handlePayload();
        await loadData();
    }

    const loadData = (): Promise<any> => {
        return BaseCrudListService.loadData();
    }

    const executeBulkAction = (): Promise<any> => {
        return BaseCrudListService.executeBulkAction();
    };

    const handleUrl = (): void => {
        let urlObject: any = {}

        if (search) {
            urlObject.q = search
        }
        if (filters.status) {
            urlObject.status = filters.status
        }
        BaseCrudListService.handleUrl(urlObject);
    }

    const processFilters = (): string => {
        let filterString = "1=1";

        if (filters.status) {
            filterString += " AND status='" + filters.status + "'";
        }

        return BaseCrudListService.processFilters(filterString);
    }

    const processQueryParams = () => {
        let filterString = {};
        return BaseCrudListService.processQueryParams(filterString);
    }

    const processOrderBy = (): string => {
        let orderByString = '';
        return BaseCrudListService.processOrderBy(orderByString);
    }

    const handlePayload = (): void => {
        payload.current = {
            '$select': '',
            '$search': search,
            '$filter': processFilters(),
            '$queryParams': processQueryParams(),
            '$expand': '',
            '$orderby': processOrderBy(),
            '$top': pagination.pageSize,
            '$skip': pagination.pageSize * (pagination.currentPage - 1),
        }
    }

    const onChangeSwitchToggle = (checked: any, record: any) => {
        BaseCrudListService.onChangeSwitchToggle(checked, record);
    }

    const handleTableChange = (pagination: any, filters: any, sorter: any, extra: any) => {
        BaseCrudListService.handleTableChange(pagination, filters, sorter, extra);
    }

    const handleOnChanged = (fieldName: string, value: any, text?: any) => {
        if (fieldName === 'filter_status') {
            setFilters({
                ...filters,
                status: value,
            });
        }
        BaseCrudListService.handleOnChanged(fieldName, value, text);
    }

    const handleCallbackFunc = (event: any, action: string, recordId?: any, data?: any) => {
        BaseCrudListService.handleCallbackFunc(event, action, recordId, data);
    }

    const users1: Array<any> = [
        {name: 'Emma Smith', avatar: '/media/avatars/300-6.jpg'},
        {name: 'Rudy Stone', avatar: '/media/avatars/300-1.jpg'},
        {name: 'Susan Redwood', initials: 'S', color: 'primary'},
      ]

    return (
        <div className="card">
            <Form form={formRef} name="exampleListingFilterForm" initialValues={initialValues} >
                <EquipmentLatestDataFilter
                    filters={filters}
                    handleOnChanged={handleOnChanged}
                    handleCallbackFunc={handleCallbackFunc}
                />
                <EquipmentLatestDataing
                    pagination={pagination}
                    loading={loading}
                    listData={listData}
                    reloadListing={reloadListing}
                    selectedRowKeys={selectedRowKeys}
                    onChangeSwitchToggle={onChangeSwitchToggle}
                    handleOnChanged={handleOnChanged}
                    handleTableChange={handleTableChange}
                    handleCallbackFunc={handleCallbackFunc}
                />
                <EquipmentLatestDataPagination
                    pagination={pagination}
                    totalCount={totalCount}
                    handleOnChanged={handleOnChanged}
                />
            </Form>
        </div>

    );
}

export default EquipmentLatestDataController;
